import { TaskEntity } from './../types/common';
import { Achievement } from 'shared/types/api';
import { create } from 'zustand';

type ProgressStore = {
  tasks: TaskEntity[];
  achievements: Achievement[];
  currentTask: TaskEntity | null;
  setTasks: (tasks: TaskEntity[]) => void;
  setAchievements: (achievements: Achievement[]) => void;
  updateAchievement: (achievement: Achievement) => void;
  updateTask: (task: TaskEntity) => void;
  setCurrentTask: (task: TaskEntity | null) => void;
};

export const useProgressStore = create<ProgressStore>((set) => ({
  tasks: [],
  achievements: [],
  currentTask: null,
  setTasks: (tasks) => set({ tasks }),
  setAchievements: (achievements) => set({ achievements }),
  updateAchievement: (achievement) =>
    set((state) => ({
      achievements: state.achievements.map((a) => (a.uuid === achievement.uuid ? achievement : a)),
    })),
  updateTask: (task) =>
    set((state) => ({ tasks: state.tasks.map((t) => (t.id === task.id ? task : t)) })),
  setCurrentTask: (task) => set({ currentTask: task }),
}));
